<router-outlet></router-outlet>
<adam-toasts aria-live="polite" aria-atomic="true"></adam-toasts>
@if (isLoader) {
<adam-spinner></adam-spinner>
} @if (show) {
<ngb-toast class="toast" header="Downloading Files..." [autohide]="false">
  <ngb-progressbar
    class="downloadProgress"
    type="secondary"
    [striped]="true"
    [animated]="true"
    [value]="progressValue"
    height="6px"
  ></ngb-progressbar>
  <br />
  <p style="margin-bottom: 0">
    {{ downloadCount }} of {{ totalDownloadCount }}
  </p>
</ngb-toast>
}
